import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Input from 'components/Input';
import styles from './SignupForm.module.scss';

export default function InputField({
  classes,
  error,
  fieldName,
  inputRef,
  labelText,
  testid,
  validating,
  width,
  ...otherProps
}) {
  return (
    <div
      className={classnames(
        styles.topLabel,
        styles[width],
        classes.fieldWrapper,
      )}
    >
      <label htmlFor={fieldName}>{labelText}</label>
      <Input
        {...otherProps}
        className={classnames(styles.field, {
          [styles.error]: error,
          [styles.validating]: validating,
        })}
        data-testid={testid}
        inputRef={inputRef}
        name={fieldName}
        type="text"
      />
      {error && (
        <span
          role="alert"
          className={styles.errorText}
          data-testid={`${testid}_error`}
        >
          {error.message}
        </span>
      )}
    </div>
  );
}

InputField.propTypes = {
  classes: PropTypes.shape({
    fieldWrapper: PropTypes.string,
  }),
  error: PropTypes.shape({
    type: PropTypes.string.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }),
  fieldName: PropTypes.string.isRequired,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  labelText: PropTypes.string.isRequired,
  testid: PropTypes.string.isRequired,
  validating: PropTypes.bool,
  width: PropTypes.oneOf(['fullWidth', 'halfWidth', 'nameFieldWidth']),
};

InputField.defaultProps = {
  classes: {},
  error: null,
  inputRef: null,
  validating: false,
  width: 'fullWidth',
};
